import React, { useMemo } from "react";
import { SbTable } from "uiCore";
import { PlanTableWrapperStyled } from "../ViewPlanningV2.styles";
import { buildPlanColumns } from "../useViewPlanningColumns";
import { tableEmptyLocale } from "../ViewPlanningV2.utils";

// Every tab's saved-plans list. `plans` is null while loading; onEdit,
// onExport and extraColumns must be stable for the columns memo to hold.
const PlansListTable = ({ plans, emptyMessage, onOpenPlan, onEdit, onExport, exportingPlanIds, extraColumns }) => {
  const columns = useMemo(
    () => buildPlanColumns(plans || [], onEdit, extraColumns, { onExport, exportingPlanIds }),
    [plans, onEdit, extraColumns, onExport, exportingPlanIds]
  );
  return (
  <PlanTableWrapperStyled>
    <SbTable
      columns={columns}
      dataSource={plans || []}
      rowKey="plan_id"
      sticky
      onRow={(record) => ({ onClick: () => onOpenPlan(record) })}
      locale={tableEmptyLocale(plans, emptyMessage)}
    />
  </PlanTableWrapperStyled>
  );
};

export default PlansListTable;
